"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.registerManualAccount = exports.queryLeverageConfigure = exports.querySymbolLeverages = exports.queryFutureBalance = exports.queryHistoryPositions = exports.queryPositions = exports.queryHistoryOrders = exports.queryActiveOrders = exports.setFuturesLeverage = exports.queryCustomOrder = exports.deleteCustomOrder = exports.postCustomOrder = exports.getFutureMarketIndexes = exports.getFutureHistoryRates = exports.getFutureMarkets = void 0;
const operators_1 = require("rxjs/operators");
const trade_utils_lib_1 = require("trade_utils_lib");
const utils_1 = require("./utils");
/**
 *
 * @returns 获取合约交易市场信息
 */
const getFutureMarkets = () => {
    const host = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().publicApiHost;
    const url = host + "/future_markets/";
    return trade_utils_lib_1.NetworkUtils.get({ url });
};
exports.getFutureMarkets = getFutureMarkets;
/**获取历史资金费率 */
const getFutureHistoryRates = (params) => {
    const host = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().futureApiHostV2;
    const url = host + "/market/funding_rates";
    return trade_utils_lib_1.NetworkUtils.get({ url, data: params });
};
exports.getFutureHistoryRates = getFutureHistoryRates;
/**
 * 获取指数价格集合
 * @param symbols 数组交易对标识符
 * @returns 指数价格集合的Observable
 */
const getFutureMarketIndexes = (symbols) => {
    const host = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().futureApiHostV2;
    const url = host + "/market/indexes";
    // FIX: 当且仅当symbols非空时，传入symbol参数
    return trade_utils_lib_1.NetworkUtils.get({ url, data: symbols.length ? { symbol: symbols.join(",") } : undefined });
};
exports.getFutureMarketIndexes = getFutureMarketIndexes;
/** 开单 */
const postCustomOrder = (request) => {
    return (0, utils_1.requestWithSignV2)({
        accountType: request.accountType,
        api: "/order",
        method: "POST",
        data: request,
    });
};
exports.postCustomOrder = postCustomOrder;
/** 关单 */
const deleteCustomOrder = (request) => {
    return (0, utils_1.requestWithSignV2)({
        accountType: request.accountType,
        api: "/order/" + request.order_id,
        method: "DELETE",
        query: {
            symbol: request.symbol,
        },
    });
};
exports.deleteCustomOrder = deleteCustomOrder;
/** 查询订单 */
const queryCustomOrder = (request) => {
    return (0, utils_1.requestWithSignV2)({
        accountType: request.accountType,
        api: "/order/" + request.order_id,
        method: "GET",
        query: {
            symbol: request.symbol,
        },
    });
};
exports.queryCustomOrder = queryCustomOrder;
/**设置合约的杠杆倍数 */
function setFuturesLeverage(data) {
    return (0, utils_1.requestWithSignV2)({
        accountType: trade_utils_lib_1.AccountTradeType.trader,
        api: "/trade/leverage",
        method: "POST",
        data: data,
    });
}
exports.setFuturesLeverage = setFuturesLeverage;
/**查询活跃订单 */
function queryActiveOrders(params) {
    return (0, utils_1.requestWithSignV2)({
        accountType: params.accountType,
        api: "/trade/active_orders",
        method: "GET",
        query: params,
    }).pipe((0, operators_1.map)((resp) => (0, utils_1.processPageCursorData)(resp, "orders")));
}
exports.queryActiveOrders = queryActiveOrders;
/**查询历史订单 */
function queryHistoryOrders(params) {
    return (0, utils_1.requestWithSignV2)({
        accountType: params.accountType,
        api: "/trade/history_orders",
        method: "GET",
        query: params,
    }).pipe((0, operators_1.map)((resp) => (0, utils_1.processPageCursorData)(resp, "orders")));
}
exports.queryHistoryOrders = queryHistoryOrders;
/**查询当前仓位 */
function queryPositions(params) {
    return (0, utils_1.requestWithSignV2)({
        accountType: trade_utils_lib_1.AccountTradeType.trader,
        api: "/trade/positions",
        method: "GET",
        query: params,
    });
}
exports.queryPositions = queryPositions;
/**查询历史仓位 */
function queryHistoryPositions(params) {
    return (0, utils_1.requestWithSignV2)({
        accountType: trade_utils_lib_1.AccountTradeType.trader,
        api: "/trade/history_positions",
        method: "GET",
        query: params,
    });
}
exports.queryHistoryPositions = queryHistoryPositions;
/**查询当前balance 以及 仓位 */
function queryFutureBalance(params) {
    return (0, utils_1.requestWithSignV2)({
        accountType: params.accountType,
        api: "/trade/account_detail",
        method: "GET",
    });
}
exports.queryFutureBalance = queryFutureBalance;
/** 查询币对对应的杠杆倍数 */
function querySymbolLeverages(symbol) {
    return (0, utils_1.requestWithSignV2)({
        accountType: trade_utils_lib_1.AccountTradeType.trader,
        api: "/trade/leverage",
        method: "GET",
    });
}
exports.querySymbolLeverages = querySymbolLeverages;
/** 查询杠杆阶梯配置 */
function queryLeverageConfigure(symbol) {
    const host = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().publicApiHost;
    const url = host + "/risk_table/";
    return trade_utils_lib_1.NetworkUtils.get({ url, data: symbol ? { symbol: symbol } : undefined });
}
exports.queryLeverageConfigure = queryLeverageConfigure;
/** 注册交易员账户 */
function registerManualAccount() {
    const host = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().manageApiHost;
    const url = host + "/api_key/";
    return trade_utils_lib_1.NetworkUtils.postWithAccessAndSpotAuth({ url, data: { market: "trader" } });
}
exports.registerManualAccount = registerManualAccount;
